import { React } from "react";

const AccountIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
    >
      <path d="M13.3549 12.331C15.9869 12.331 18.1205 10.1974 18.1205 7.56549C18.1205 4.93354 15.9869 2.79993 13.3549 2.79993C10.723 2.79993 8.58936 4.93354 8.58936 7.56549C8.58936 10.1974 10.723 12.331 13.3549 12.331Z" />
      <path d="M18.6143 14.1332H8.40787C5.2967 14.1332 3.79671 18.2142 6.15754 20.3421C8.13396 22.1232 10.7033 23.1998 13.5129 23.1998C16.2773 23.1998 18.8094 22.1575 20.773 20.4268C23.202 18.2858 21.7859 14.1332 18.6143 14.1332Z" />
    </svg>
  );
};

export default AccountIcon;
